import { Fragment } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Profile from "../../Feature/customer/settings/profile/index";
import Addresses from "../../Feature/customer/settings/address/index";
import Notification from "../../Feature/customer/notification";
import CustomerHome from "../../Feature/customer/home/index";
import PickupDetails from "../../Feature/customer/placeOrder/pickupDetails/index";
import PlaceOrder from "../../Feature/customer/placeOrder";
import AddToCart from "../../Feature/customer/placeOrder/AddToCart";
import SelectShop from "../../Feature/customer/placeOrder/selectShop";
import ReviewAndPlaceOrder from "../../Feature/customer/placeOrder/reviewAndPlaceOrder";
import Settings from "../../Feature/customer/settings";
import MyOrders from "../../Feature/customer/settings/myOrders/index";
import OrderTracking from "../../Feature/customer/settings/orderTracking";
import Favourite from "../../Feature/customer/settings/favourite";
import OfferedLaundry from "../../Feature/customer/settings/offeredLaundry";
import OrderFailuer from "../../Feature/customer/orderFailuer";
import OrderSuccess from "../../Feature/customer/orderSuccess";
import { useSelector } from "react-redux";

const CustomerAuth = () => {
    const { loginDetails } = useSelector((state) => state.counter);

  if (loginDetails?.userType !== "normal user") {
    return <Navigate to="/" replace />
  }
  return (
    <Fragment>
      <main
        className={`h-[calc(100vh-5px)] overflow-auto scrollbar-hide bg-[var(--bg-surface)]  pt-[80px] transition-all duration-300  `}
      >
        <div className="">
          <Routes>
            <Route
              path="/customer-home"
              element={<CustomerHome />}
              exact
            ></Route>
            <Route path="/customer/confirm-order" element={<OrderSuccess/>} />
            <Route path="/customer/failed-order" element={<OrderFailuer />} />
            <Route path="/notification" element={<Notification />} />
            <Route path="" element={<PlaceOrder />}>
              <Route path="pickup-details" element={<PickupDetails />} />
              <Route path="add-to-cart" element={<AddToCart />} />
              <Route path="shop-selection" element={<SelectShop />} />
              <Route
                path="review-place-order"
                element={<ReviewAndPlaceOrder />}
              />
            </Route>
            <Route path="" element={<Settings />}>
              <Route path="/profile" element={<Profile />} />
              <Route path="/addresses" element={<Addresses />} />
              <Route path="/my-orders" element={<MyOrders />} />
              <Route path="/order-tracking" element={<OrderTracking />} />
              <Route path="/order-tracking/:id" element={<OrderTracking />} />
              <Route path="/favourite" element={<Favourite />} />
              <Route path="/offered-laundry" element={<OfferedLaundry />} />
            </Route>
          </Routes>
        </div>
      </main>
    </Fragment>
  );
};

export default CustomerAuth;
